import Api from '@utils/api';
import { Personal } from '@constants/urls';

export const state = {
	personal: [],
	aspirantes: [],
	persona: {},
	filtro: '',
	loading: false,
	loading_action: false
};

export const getters = {
	getPersonal(state) {
		return state.personal;
	},
	getPersona(state) {
		return state.persona;
	},
	getLoading(state) {
		return state.loading;
	},
	getLoadingAction(state) {
		return state.loading_action;
	},
	getAspirantes(state) {
		return state.aspirantes;
	}
};

export const mutations = {
	SET_PERSONAL(state, newValue) {
		state.personal = newValue;
	},
	SET_PERSONA(state, newValue) {
		state.persona = newValue;
	},
	SET_ASPIRANTES(state, newValue) {
		state.aspirantes = newValue;
	},
	SET_LOADING_FILES(state, newValue) {
		state.loading_action = newValue;
	},
	SET_FILTRO(state, newValue) {
		state.filtro = newValue;
	},
	SET_LOADING(state, newValue) {
		state.loading = newValue;
	}
};

export const actions = {
	inicializar({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(Personal.LISTAR)
			.then((response) => {
				commit('SET_PERSONAL', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	establecerPersona({ commit }, persona) {
		commit('SET_PERSONA', persona);
	},
	establecerFiltro({ commit }, { filtro }) {
		commit('SET_FILTRO', filtro);
	},
	subirArchivoCsv({ commit }, { archivos, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(Personal.IMPORTAR, archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodos({ commit }, { onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Personal.ELIMINAR_TODOS)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	obtenerPersona({ commit }, { clavePersonal, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(Personal.OBTENER(clavePersonal))
			.then((response) => {
				commit('SET_PERSONA', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerAspirantes({ commit }, { clavePersonal, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(Personal.OBTENER_ASPIRANTES(clavePersonal))
			.then((response) => {
				commit('SET_ASPIRANTES', response.data.data);
				onComplete(response);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	subirArchivoAspirantesCsv(
		{ commit },
		{ clavePersonal, archivos, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(Personal.CREAR_ASPIRANTES(clavePersonal), archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodosAspirantes({ commit }, { clavePersonal, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Personal.ELIMINAR_TODOS_ASPIRANTES(clavePersonal))
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarAspirantes(
		{ commit },
		{ clavePersonal, ficha, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Personal.ELIMINAR_ASPIRANTE(clavePersonal, ficha))
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	crearPersonal({ commit }, { params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Post(Personal.CREAR, params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	editarPersonal({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Personal.EDITAR(clave), params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	restablecerContraseniaPersonal(
		{ commit },
		{ clave, params, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Personal.RESTABLECER_CONTRASENIA(clave), params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarPersonal({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Personal.ELIMINAR(clave), params)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	subirAspirantesPersonalCsv({ commit }, { archivos, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(Personal.ASIGNAR_ASPIRANTES, archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodosAspirantesPersonal({ commit }, { onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Personal.ELIMINAR_TODOS_ASPIRANTE_PERSONAL)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	}
};
